<!--监测设备-->
<template>
	<treeBody>
		<!--左边-->
		<virtualDeviceTree slot="tree" :dataList="virtualDeviceList" @checkItem="$store.deviceStore.commit('setNowVirtualDevice',$event)" :autoSelectMethod='autoSelectMethod'></virtualDeviceTree>
		<!--右边-->
		<div class="monreportRigth" slot="body" style="overflow: overlay;">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>用户信息</span>
				</div>
				<div class="text item">
					<el-table :data="unitTableData" stripe style="width: 100%" border>
						<el-table-column prop="name" label="用户名称" width="180">
						</el-table-column>
						<el-table-column prop="address" label="用户地址" width="180">
						</el-table-column>
						<el-table-column prop="leader" label="联系人">
						</el-table-column>
						<el-table-column prop="phoneNum" label="联系人电话">
						</el-table-column>
						<el-table-column prop="inletWire" label="进线来源">
						</el-table-column>
						<el-table-column prop="joinTime" label="安装时间">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>在线监测</span>
				</div>
				<div class="text item" style="display: flex;align-items: center;justify-content: space-between;">
					<div class="value-table">
						<el-table :data="dataList" height="450" border style="width: 100%">
							<el-table-column prop="variablename" label="变量名称" width="180">
							</el-table-column>
							<el-table-column prop="value" label="实时值" width="180">
							</el-table-column>
							<el-table-column prop="dayMaxValue" label="本日最大值">
							</el-table-column>
							<el-table-column prop="monthMaxValue" label="本月最大值">
							</el-table-column>
						</el-table>
					</div>
					<div class="value-chart">
						<wenduRtChart :wenduOptions='wenduOptions' :loudianOptions='loudianOptions' :nowVariableNames='nowVariableNames'></wenduRtChart>
					</div>
				</div>
			</el-card>
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>能耗统计</span>
				</div>
				<div class="text item" style="display: flex;align-items: center;justify-content: space-between;">
					<div class="energy-value">
						<el-row>
							<el-col :span="24">
								<div class="grid-content bg-purple-dark" style="display: flex;align-items: center;justify-content: center;">
									<span>今年用电量</span>
									<span style="color: #FC3A3A;padding: 0 10px;">{{powerData.year}}</span>
									<span>(单位KWh)</span>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="3">
								<div class="grid-bottom-content bg-purple-dark" style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
									<span style="color: #FC3A3A;">{{powerData.day}}</span>
									<span>今日电量</span>
								</div>
							</el-col>
							<el-col :span="1" style='margin-left: 5px;'>
								<div class="grid-bottom-content bg-purple-dark" style="background-color:white;display: flex;flex-direction: column;justify-content: space-between;">
									<div class="compared">
										<span>同</span>
										<span>比</span>
									</div>
									<div class="compared">
										<span>环</span>
										<span>比</span>
									</div>
								</div>
							</el-col>
							<el-col :span="4" style='margin-left: 5px;'>
								<div class="grid-bottom-content bg-purple-dark" style="background-color:white;display: flex;flex-direction: column;justify-content: space-between;">
									<div class="compared-value">
										<span>{{powerData.lastMonth}}</span>
										<span>上月同期电量</span>
									</div>
									<div class="compared-value">
										<span>{{powerData.lastDay}}</span>
										<span>昨日同期电量</span>
									</div>
								</div>
							</el-col>
							<el-col :span="4" style='margin-left: 5px;'>
								<div class="grid-bottom-content bg-purple-dark" style="background-color:white;display: flex;flex-direction: column;justify-content: space-between;">
									<div class="compared-value">
										<span>{{powerData.lastMonthRatio}}</span>
										<span>上月同期相比</span>
									</div>
									<div class="compared-value">
										<span>{{powerData.lastDayRatio}}</span>
										<span>昨日同期相比</span>
									</div>
								</div>
							</el-col>
							<el-col :span="3">
								<div class="grid-bottom-content bg-purple-dark" style="margin-left:5px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
									<span style="color: #FC3A3A;">{{powerData.lastMonth}}</span>
									<span>本月电量</span>
								</div>
							</el-col>
							<el-col :span="1" style='margin-left: 5px;'>
								<div class="grid-bottom-content bg-purple-dark" style="background-color:white;display: flex;flex-direction: column;justify-content: space-between;">
									<div class="compared">
										<span>同</span>
										<span>比</span>
									</div>
									<div class="compared">
										<span>环</span>
										<span>比</span>
									</div>
								</div>
							</el-col>
							<el-col :span="4" style='margin-left: 5px;'>
								<div class="grid-bottom-content bg-purple-dark" style="background-color:white;display: flex;flex-direction: column;justify-content: space-between;">
									<div class="compared-value">
										<span>{{powerData.lastYearMonth}}</span>
										<span>上年同期电量</span>
									</div>
									<div class="compared-value">
										<span>{{powerData.lastMonthDay}}</span>
										<span>上月同期电量</span>
									</div>
								</div>
							</el-col>
							<el-col :span="4" style='margin-left: 5px;'>
								<div class="grid-bottom-content bg-purple-dark" style="background-color:white;display: flex;flex-direction: column;justify-content: space-between;">
									<div class="compared-value">
										<span>{{powerData.lastMonthDayRatio}}</span>
										<span>上年同期相比</span>
									</div>
									<div class="compared-value">
										<span>{{powerData["lastYearMonthRatio"]}}</span>
										<span>上月同期相比</span>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
					<div class="energy-chart">
						<vchart ref='energyVchart' style='height: 250px;'></vchart>
					</div>
				</div>
			</el-card>
			<el-card class="box-card" v-show='false'>
				<div slot="header" class="clearfix">
					<span>隐患统计</span>
				</div>
				<div class="text item">
					<eventChart></eventChart>
				</div>
			</el-card>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import eventChart from '@/page/system/zhanyd/eventChart.vue'
	import wenduRtChart from '@/page/system/zhanyd/wenduRtChart.vue'
	export default {
		components: {
			virtualDeviceTree,
			treeBody,
			elRadioTree,
			vchart,
			eventChart,
			wenduRtChart,
		},
		props: {},
		data() {
			return {
				unitTableData: [],
				onlineTable: [],
				from2name: {},
				maximumList: {},
				powerData: {
					day: 0,
					lastDay: 0,
					lastDayRatio: 0,
					lastMonth: 0,
					lastMonthRatio: 0,
					lastMonthDay: 0,
					lastMonthDayRatio: 0,
					lastYearMonth: 0,
					lastYearMonthRatio: 0,
					month: 0,
					year: 0,
				},
				wenduChartValue: [],
				energyOptions: {
					xAxis: [{
						type: 'category',
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
							'20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'
						],
						axisLabel: {
							textStyle: {
								color: 'black',
							},
						},
						splitLine: {
							show: true
						},
					}],
					yAxis: [{
						title: '能耗值（KWH）',
						type: 'value',
						axisLabel: {
							textStyle: {
								color: 'black',
							},
						},
						splitLine: {
							show: true
						},
					}],
					legend: {
						x: 'center',
						y: 'bottom',
						align: 'auto',
						padding: [0, 0, 20, 0],
						data: ['电量', '电费'],
					},
					backgroundColor: '',
					tooltip: {
						trigger: 'axis',
						confine: true,
						formatter: (params, ticket, callback) => {
							var nowMonth = new Date().getMonth() + 1
							var label = '日用电量统计</br>' + nowMonth + '月' + params[0].axisValue + " 日</br>"
							params.forEach(item => {
								var values;
								if(this.$historyTools.isNull(item.data)) {
									values = "无采集数据";
								} else {
									values = cutDigital(item.data);
								}
								label += item.seriesName + " : " + values + "</br>"
							})
							return label;
						},
						axisPointer: {
							animation: false
						}
					},
					grid: {
						height: '60%',
						left: '1%',
						right: '0',
						bottom: '0%',
						top: '20%',
						containLabel: true
					},
					series: []
				},
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.$refs.energyVchart.setData(this.energyOptions, true)
			this.initData()
			this.maximumData()
			this.realTimeValueStore.commit("addKeys", this.nowVariableNames)
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowVariableNames)
		},
		computed: {
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [data]
			},
			nowDevice() {
				//当前选中的设备
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			nowUnit() {
				//选中的id
				return this.$store.unitStore.getters.getNowUnit
			},
			variableStore() {
				return this.$store.variableStore
			},
			variableTree() {
				if(isempty(this.nowDevice)) {
					return []
				}
				return this.variableStore.getters.getVariableTree(this.nowDevice.no)
			},
			apptypeGroups() {
				//所有已选中的设备所具有的变量类型组
				var list = []
				var apptypeGroupIds = []
				this.variableTree.forEach(apptypeGroup => {
					if(!apptypeGroupIds.includes(apptypeGroup.id)) {
						apptypeGroupIds.push(apptypeGroup.id)
						list.push(apptypeGroup)
					}
				})
				//排序
				return list.sort((a, b) => {
					return a.serialnum - b.serialnum
				})
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				var ag = this.apptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						this.from2name[i.fromName] = i.name + item.unit
						v2.push(i.fromName)
					})
				})
				return v2
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			dataList() {
				//获取值
				var vl = this.realTimeValueStore.getters.getValue(this.nowVariableNames)
				var deviceList = this.nowVariableNames.map(item => item.substring(0, item.indexOf('.'))).distinct()
				var deviceStateMap = this.realTimeValueStore.getters.getDeviceState(deviceList)
				var v2 = this.realTimeValueStore.getters.getTime(this.nowVariableNames)
				//获取当前设备状态
				return this.nowVariableNames.map((item, index) => {
					var value = this.realTimeValueStore.getters.getText(item, vl[index])
					let dayMaxValue = '--'
					let monthMaxValue = '--'
					if(isNaN(parseFloat((vl[index]))) || isnull(parseFloat((vl[index])))) {
						value = "- -"
					}
					var name = this.from2name[item] ? this.from2name[item] : item
					let deviceName = ''
					this.variableTree.forEach(item2 => {
						if(item2.name == item) {
							deviceName = item2.devicename
						}
					})
					if(!isempty(this.maximumList)) {
						for(let key in this.maximumList) {
							if(key == item) {
								dayMaxValue = this.maximumList[key].day.max
								monthMaxValue = this.maximumList[key].month.max
							}
						}
					}
					return {
						dayMaxValue: dayMaxValue,
						monthMaxValue: monthMaxValue,
						devicename: deviceName,
						variablename: name.subByFirstChar("."),
						value,
					}
				})
			},
			wenduOptions() {
				let list = []
				this.apptypeGroups.forEach(item => {
					if(item.name == '温度') {
						list = item.next
					}
				})
				list.forEach(item => {
					item.lable = item.fromName.split('.')[1]
				})
				return list
			},
			loudianOptions() {
				let list = []
				this.apptypeGroups.forEach(item => {
					if(item.name == '漏电') {
						list = item.next
					}
				})
				list.forEach(item => {
					item.lable = item.fromName.split('.')[1]
				})
				return list
			},
			searchAllEventTypes() {
				//事件类型
				return this.$store.eventStore.getters.searchAllEventTypes
			},
		},
		watch: {
			nowVariableNames(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
				this.maximumData()
			},
			nowDevice(nv, ov) {
				this.initData()
			},
		},
		methods: {
			autoSelectMethod(item, index) {
				if(this.nowDevice != undefined) {
					return this.nowDevice.id == item.id && this.nowDevice.type == item.type
				} else {
					return item.type == 'virtualDevice'
				}
			},
			initData() {
				this.unitTableData = []
				this.$api.deviceApi.getUnitByVirtualDeviceNo(this.nowDevice.id, respon => {
					if(!isempty(respon.joinTime)) {
						respon.joinTime = new Date(respon.joinTime).format('yyyy-MM-dd')
					}
					this.unitTableData.push(respon)
				})
				//获取单位看板数据
				this.$api.powerApi.getUnitUsePower(this.nowUnit.id, this.nowDevice.id, respon => {
					this.powerData = respon
					this.powerData.lastDayRatio = respon['lastDay%']
					this.powerData.lastMonthRatio = respon['lastYearMonth%']
					this.powerData.lastMonthDayRatio = respon['lastMonthDay%']
					this.powerData.lastYearMonthRatio = respon['lastYearMonth%']
				})
				//查询温度和漏电的历史值
				let dayTime = new Date().format('yyyy-MM-dd')
				let startTime = new Date(dayTime + ' 00:00:00').getTime()
				let endTime = new Date().getTime()
				let day = new Date().format('yyyyMMdd')
				//查询设备用电量
				this.$api.powerApi.getClassPGByMonthForHuaPudviceNos(this.nowUnit.id, startTime, this.nowDevice.id, respon => {
					var money = []
					var power = []
					if(!isempty(respon)) {
						Object.keys(respon).forEach(key => {
							var pw = respon[key]['总电量']
							var my = respon[key]['总电费']
							if(this.$historyTools.isNull(my)) {
								my = undefined
							}
							if(this.$historyTools.isNull(pw)) {
								pw = undefined
							}
							money.push(my)
							power.push(pw)
						})
					}
					this.energyOptions.series = [{
						name: '电量',
						type: 'bar',
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0, 0, 0, 1, [{
											offset: 0,
											color: '#005ae1'
										},
										{
											offset: 1,
											color: '#34abff'
										}
									]
								)
							},
							emphasis: {
								color: new echarts.graphic.LinearGradient(
									0, 0, 0, 1, [{
											offset: 0,
											color: '#00c6ff'
										},
										{
											offset: 1,
											color: '#34abff'
										}
									]
								)
							}
						},
						data: power
					}, {
						name: '电费',
						type: 'bar',
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0, 0, 0, 1, [{
											offset: 0,
											color: '#ffd200'
										},
										{
											offset: 1,
											color: '#e68b11'
										}
									]
								)
							},
							emphasis: {
								color: new echarts.graphic.LinearGradient(
									0, 0, 0, 1, [{
											offset: 0,
											color: '#ff8400'
										},
										{
											offset: 1,
											color: '#ffd200'
										}
									]
								)
							}
						},
						data: money
					}]
					this.$refs.energyVchart.setData(this.energyOptions, true)
				})
			},
			maximumData() {
				//获取最大值
				let VariableNames = ''
				this.nowVariableNames.forEach((item, index) => {
					if(index + 1 < this.nowVariableNames.length) {
						VariableNames += item + ','
					} else {
						VariableNames += item
					}
				})
				if(isempty(VariableNames)) {
					return
				}
				this.$api.historyApi.getVariableMaxAndMin(VariableNames, new Date().getTime(), respon => {
					this.maximumList = respon
				})
			},
		}
	}
</script>

<style>
	.text {
		font-size: 14px;
	}
	
	.item {}
	
	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}
	
	.clearfix:after {
		clear: both
	}
	
	.monreportRigth .el-card__header {
		padding: 5px 9px !important;
	}
	
	.box-card {
		width: 98%;
		margin: 0 auto;
		margin-top: 0.5%;
	}
	
	.el-card__body {
		padding: 0;
	}
	
	.value-table {
		height: 450px;
		width: 50%;
	}
	
	.value-chart {
		height: 450px;
		width: 50%;
	}
	
	.energy-value {
		width: 50%;
		height: 250px;
	}
	
	.energy-chart {
		height: 250px;
		width: 50%;
	}
	
	.wendu-chart {
		height: 50%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	
	.loudian-chart {
		height: 50%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	
	.el-table td,
	.el-table th {
		padding: 5px 0
	}
	
	.el-row {
		margin-bottom: 10px;
		margin-top: 10px;
		margin-left: 20px;
		display: flex;
	}
	
	.el-col {
		border-radius: 4px;
	}
	
	.bg-purple-dark {
		background: #E0EFFF;
	}
	
	.bg-purple {
		background: #d3dce6;
	}
	
	.grid-content {
		border-radius: 4px;
		min-height: 80px;
	}
	
	.grid-bottom-content {
		border-radius: 4px;
		min-height: 130px;
	}
	
	.compared {
		background-color: #FFF0DE;
		height: 62px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.compared-value {
		background-color: #E0EFFF;
		height: 62px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
</style>